import { AuditTrialOverviewResponseModel } from "../../data-model/eventsModal";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";

export interface GetAuditTrialOverviewPayload {
  order_id: string;
}

export const getAuditTrialOverview = async (
  payload: GetAuditTrialOverviewPayload,
) => {
  try {
    const response = await fetch(API_ENDPOINTS.AUDIT_TRIAL_OVERVIEW, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch audit trial overview");
    }

    const data = await response.json();
    return data as AuditTrialOverviewResponseModel;
  } catch (error) {
    logError(error as Error, "Error in getAuditTrialOverview");
    throw error;
  }
};
